/**
 * 把数据存储到路由中
 * @param data 需要存储的数据
 * @returns 路由中 search 字段，即数据存在seesionStorge中对应的key，一般是__开头
 */
function setSearch(data) {
  var key = "__" + Math.random().toString(36).slice(-6);

  if (typeof data === 'object') {
    window.sessionStorage.setItem(key, JSON.stringify(data));
  } else {
    window.sessionStorage.setItem(key, data);
  }

  return "_=" + key;
}
/**
 * 获取路由中的数据
 * @param search 路由search中的字段
 * @returns 返回是经过JSON.parse处理过的数据
 */


function getSearch(search) {
  if (!search) return '';
  var params = search.split('?')[1].split('&');
  var obj = {};
  params.forEach(function (item) {
    return obj[item.split('=')[0]] = item.split('=')[1];
  });
  var state = window.sessionStorage.getItem(obj._) || '';

  if (state !== '') {
    state = JSON.parse(state);
  }

  return state;
}

export default {
  setSearch: setSearch,
  getSearch: getSearch
};